import React, { useState } from 'react';
import styled from 'styled-components';
import man from '../../../Assets/Images/man.svg';

const Container = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 0 auto;
`;

const CustomerAvatar = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #ccc;
  margin: 0 auto 20px;
`;

const Testimonial = styled.blockquote`
  font-style: italic;
  margin-bottom: 20px;
`;

const CustomerName = styled.p`
  font-weight: bold;
  margin-bottom: 5px;
`;

const Location = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
`;

const Rating = styled.div`
  color: #ffc107;
  font-size: 24px;
`;

const Navigation = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const NavigationButton = styled.button`
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

const TestimonialComponent = () => {
  const testimonials = [
    {
      text: "I had no idea we had the access to so many insurance policies. Buy Policy helped me secure the lives of my wife and children by helping me secure the best policy for myself.",
      name: "Mr. Shivaji Durgappa Powar",
      location: "Maharashtra, India",
      rating: 5,
    },
    {
      text: "Buy Policy made it easy for me to compare different insurance options and find the one that fit my needs and budget. Their customer service was also top-notch.",
      name: "Mrs. Neha Sharma",
      location: "Delhi, India",
      rating: 4,
    },
    {
      text: "I was hesitant to buy insurance online, but the team at Buy Policy guided me through the process and answered all my questions. Now I have peace of mind knowing my family is protected.",
      name: "Mr. Rajesh Patel",
      location: "Gujarat, India",
      rating: 5,
    },
    // Add one more testimonial
    {
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam nec varius odio. In non purus in nulla consequat lobortis. Integer id neque a metus tincidunt gravida. Nullam ullamcorper, odio vel finibus volutpat, justo nisi cursus est, at pharetra justo nisi nec elit.",
      name: "Lorem Ipsum",
      location: "Unknown",
      rating: 3,
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((currentIndex - 1 + testimonials.length) % testimonials.length);
  };

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % testimonials.length);
  };

  // Calculate the index of the next testimonial to display
  const nextIndex = (currentIndex + 1) % testimonials.length;

  return (
    <Container>
      <div className="d-flex justify-content-between">
        {/* Render the current testimonial */}
        <div>
          <img src={man} alt='man' style={{ width: "80px", height: "80px", borderRadius: "50%", backgroundColor: "#ccc", margin: "0 auto 20px", display: "block" }} />
          <Testimonial>{testimonials[currentIndex].text}</Testimonial>
          <CustomerName>{testimonials[currentIndex].name}</CustomerName>
          <Location>{testimonials[currentIndex].location}</Location>
          <Rating>
            {Array(testimonials[currentIndex].rating)
              .fill('★')
              .map((star, index) => (
                <span key={index}>{star}</span>
              ))}
          </Rating>
        </div>
        {/* Render the next testimonial */}
        <div>
          <img src={man} alt='man' style={{ width: "80px", height: "80px", borderRadius: "50%", backgroundColor: "#ccc", margin: "0 auto 20px", display: "block" }} />
          <Testimonial>{testimonials[nextIndex].text}</Testimonial>
          <CustomerName>{testimonials[nextIndex].name}</CustomerName>
          <Location>{testimonials[nextIndex].location}</Location>
          <Rating>
            {Array(testimonials[nextIndex].rating)
              .fill('★')
              .map((star, index) => (
                <span key={index}>{star}</span>
              ))}
          </Rating>
        </div>
      </div>
      <Navigation>
        <NavigationButton onClick={handlePrevious}>{'<'}</NavigationButton>
        <NavigationButton onClick={handleNext}>{'>'}</NavigationButton>
      </Navigation>
    </Container>
  );
};

export default TestimonialComponent;
